import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Shared loading spinner component.
 * Replaces the duplicated Box + CircularProgress pattern across 20+ pages.
 *
 * @param {object} props
 * @param {boolean} [props.fullPage=false] - Use full viewport height centering
 * @param {string} [props.message] - Optional loading message below spinner
 * @param {number} [props.size=40] - Spinner size in px
 */
const LoadingSpinner = ({ fullPage = false, message, size = 40 }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        p: 4,
        ...(fullPage && { minHeight: '60vh' }),
      }}
    >
      <CircularProgress size={size} />
      {message && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingSpinner;
